import HRCreateJob from "src/components/job/hr/CreateJob";

export default function CreateJob() {

  return (
    <div className="w-11/12 max-w-7xl mx-auto">
      <HRCreateJob/>
    </div>
  )
}
